import { useState, type FormEvent } from "react";

const FORM_URL = "https://readdy.ai/api/form/dagj1dptto0ceqqnhsng";

export default function SubscribeSection() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = (fd.get("company_alt") as string) || "";
    if (honeypot.trim() !== "") {
      setStatus("success");
      form.reset();
      setEmail("");
      return;
    }
    fd.delete("company_alt");
    setStatus("loading");
    setFormError("");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = {};
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || responseText || "";
      if (res.ok && parsed?.code === "OK" && !/spam/i.test(serverMsg)) {
        setStatus("success");
        form.reset();
        setEmail("");
      } else {
        setFormError(serverMsg || "订阅失败，请稍后重试。");
        setStatus("error");
      }
    } catch {
      setFormError("网络异常，请稍后重试。");
      setStatus("error");
    }
  };

  return (
    <section id="subscribe" className="scroll-mt-20 bg-background-950 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-4 py-1.5 text-sm font-bold text-foreground-950">
          <i className="ri-notification-3-line"></i>
          免费订阅 · 随时可退
        </span>
        <h2 className="mt-4 font-heading text-3xl font-black tracking-tight text-background-50 md:text-4xl">
          订阅追更，反转不再错过
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-background-200/85 md:text-base">
          留下邮箱，当追踪中的事件出现辟谣、反转、当事人回应或新瓜进展时，第一时间推送给您。
          信息均经核实后推送，不刷屏、不打扰。
        </p>

        <form
          data-readdy-form="订阅追更"
          onSubmit={handleSubmit}
          className="mx-auto mt-7 flex max-w-xl flex-col gap-3 sm:flex-row"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="请输入常用邮箱地址"
            className="w-full rounded-md border border-background-200/30 bg-background-100/10 px-4 py-3 text-sm text-background-50 placeholder:text-background-400 outline-none transition-colors focus:border-accent-400 focus:bg-background-100/20"
          />
          {/* honeypot */}
          <input
            type="text"
            name="company_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="company-hp"
          />
          <button
            type="submit"
            disabled={status === "loading"}
            className="inline-flex items-center justify-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-sm font-bold whitespace-nowrap text-foreground-950 transition-colors hover:bg-accent-400 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {status === "loading" ? (
              <>
                <i className="ri-loader-4-line animate-spin"></i>
                提交中…
              </>
            ) : (
              <>
                <i className="ri-send-plane-line"></i>
                立即订阅
              </>
            )}
          </button>
        </form>

        {status === "success" && (
          <p className="fade-in mx-auto mt-4 inline-flex items-center gap-2 rounded-md bg-secondary-500/20 px-4 py-2 text-sm font-medium text-secondary-300">
            <i className="ri-checkbox-circle-line"></i>
            订阅成功！新瓜反转我们将第一时间通知您。
          </p>
        )}
        {status === "error" && formError && (
          <p className="fade-in mx-auto mt-4 inline-flex items-center gap-2 rounded-md bg-primary-500/20 px-4 py-2 text-sm font-medium text-primary-200">
            <i className="ri-error-warning-line"></i>
            {formError}
          </p>
        )}
        <p className="mt-4 text-xs text-background-400">
          提交即表示同意接收追更推送。您的邮箱仅用于本站内容通知，不会向第三方共享。
        </p>
      </div>
    </section>
  );
}